<div class="full-column">
	<app-hub-nav-header
		sportCode="golf"
		currentRoute="tournament"
	></app-hub-nav-header>
	<div class="page-description" >
		<h1 class="page-title"> Golf Predictions </h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
	<app-golf-tournament-block *ngIf="tournConfig" [configurationObject]="tournConfig"></app-golf-tournament-block>
    <app-best-offers sportCode="GOLF" *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
</div>